import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Text } from '@reveni-io/reveni-ui'

const ChipLabel = ({ portals, portalsInUse }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  return (
    <Text type="bodySRegular" color={theme.colors.info.hover}>
      {t('En uso en')}{' '}
      <Text type="bodySBold" tag="span">
        {`${portalsInUse.length} ${t('de')} ${portals.length} ${t('portales')}`}
      </Text>
    </Text>
  )
}

export default ChipLabel
